import { getFullscreenElement } from '..';

const useToggleFullscreen = viewRef => {
  const toggleFullScreen = async () => {
    const fullScreenElement = getFullscreenElement();
    const frame = viewRef.current;

    try {
      if (fullScreenElement === null) {
        if (frame?.requestFullscreen) {
          await frame.requestFullscreen();
        }
        if (frame?.webkitEnterFullScreen) {
          await frame.webkitEnterFullScreen();
        }
        if (frame?.webkitRequestFullscreen) {
          await frame.webkitRequestFullscreen();
        }
        if (frame?.webkitEnterFullscreen) {
          await frame.webkitEnterFullscreen();
        } else if (frame?.mozRequestFullScreen) {
          await frame.mozRequestFullScreen();
        } else if (frame?.webkitRequestFullScreen) {
          await frame.webkitRequestFullScreen();
        } else if (frame?.msRequestFullscreen) {
          await frame.msRequestFullscreen();
        }
      } else if (!!fullScreenElement && fullScreenElement !== null) {
        if (document?.exitFullscreen) {
          document.exitFullscreen();
        } else if (document?.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document?.webkitExitFullscreen) {
          document.webkitExitFullscreen();
        } else if (document?.msExitFullscreen) {
          document.msExitFullscreen();
        }
      }
    } catch (error) {
      throw new Error(`FullScreenError:::-> ${error}`);
    }
  };

  return toggleFullScreen;
};

export default useToggleFullscreen;
